module.exports = __webpack_public_path__ + "images/category_lp/earphone/new/store_images/4@2x_5d9c7be7ba9890cfdf81b71a18eb3355.png";